import { getFeatureProfileUrls } from "../../roles/api/query";

export const checkPermission = async (module, subModule = "", action = "") => {
    // console.log("Module: ", module, " SubModule: ", subModule, " Action: ", action);
    const userRole = localStorage.getItem('user');
    const userData = JSON.parse(userRole) || {}
    const permissions = userData?.roleDetails?.permissions || {};
    if (userData?.roleDetails?.name === "Super Admin") {
        if (action === "") {
            return {
                canEdit: true,
                canCreate: true,
                canView: true,
                canDelete: true,
            };
        }
        return true;
    }
    let settings = {};
    try {
        const sessionData = sessionStorage.getItem("featureSettings");
        if (sessionData) {
            settings = JSON.parse(sessionData);
        } else {
            const settingsData = await getFeatureProfileUrls();
            settings = settingsData || {};
            sessionStorage.setItem("featureSettings", JSON.stringify(settings));
        }
    } catch (e) {
        console.error("Failed to load feature settings in permission check", e);
    }

    const featureRestrictions = {
        store: settings.isStoreSubscribed,
        "store.tableReservation": settings.isTableReservationEnabled,
        "store.qrDining": settings.isQrDiningEnabled,
        "marketing.reward": settings.isRewardsSubscribed,
        "marketing.messaging": settings.isMessagingSubscribed,
        "marketing.mediaGallery": settings.isMediaGalleryEnabled,
        analytics: settings.isAnalyticsSubscribed,
        "engagement.crm": settings.showGrowthMenu,
        "engagement.intentManager": settings.ischatBotEnabled,
        "utilities.documentManager": settings.isDocumentManagerEnabled,
    };

    const fullModulePath = subModule ? `${module}.${subModule}` : module;

    for (const key of Object.keys(featureRestrictions)) {
        const flag = featureRestrictions[key];

        if (flag !== true && typeof fullModulePath === 'string' && fullModulePath.startsWith(key)) {
            console.warn(`Blocked by feature restriction: ${fullModulePath}`);
            return false;
        }
    }

    try {
        const modulePermissions = permissions[module];
        if (!modulePermissions?.isEnabled) {
            // console.log("Has access: false");
            return false;
        }

        if (subModule) {
            const subModulesArray = subModule.split('.');

            if (subModulesArray.length === 1) {
                const subModulePermissions = modulePermissions.subModules?.[subModule];
                if (!subModulePermissions || !subModulePermissions.isEnabled) {
                    return action === "" ? { canView: false, canEdit: false, canCreate: false, canDelete: false } : false;
                }
                if (action === "") return subModulePermissions.permissions || { canView: false, canEdit: false, canCreate: false, canDelete: false };
                const hasPermission = subModulePermissions.permissions?.[action];
                return hasPermission || false;
            }

            let currentPermissions = modulePermissions;
            for (const sub of subModulesArray) {
                if (currentPermissions?.subModules && currentPermissions.subModules[sub]) {
                    currentPermissions = currentPermissions.subModules[sub];
                } else {
                    return action === "" ? { canView: false, canEdit: false, canCreate: false, canDelete: false } : false;
                }
            }

            if (!currentPermissions || currentPermissions.isEnabled === false) {
                return action === "" ? { canView: false, canEdit: false, canCreate: false, canDelete: false } : false;
            }

            if (action === "") return currentPermissions.permissions || { canView: false, canEdit: false, canCreate: false, canDelete: false };
            const hasPermission = currentPermissions.permissions && currentPermissions.permissions[action];
            return hasPermission || false;
        }

        if (action === "") return modulePermissions.permissions
        const hasPermission = modulePermissions.permissions[action];
        // console.log("Has access: ", hasPermission);
        return hasPermission;

    } catch (error) {
        console.error('Permission check failed with error:', error);
        return false;
    }
};
